export const SEARCH_API: string =
  (import.meta.env.VITE_SEARCH_API as string | undefined) ??
  "https://docs-search.will-i-bracken.workers.dev";

export interface SearchHit {
  id: string;
  filename: string;
  path: string;
  machine: string;
  size: number;
  mtime: number;
  snippet: string;
  score: number;
  sha256?: string;
  mime?: string;
  duplicates?: string[];
  blob_url?: string;
  preview?: string;
}

export interface SearchResponse {
  hits: SearchHit[];
  total: number;
  took_ms: number;
}

export interface StatsResponse {
  total_files: number;
  dedupe_savings_bytes: number;
  last_index_time: number | string;
}

export interface SearchParams {
  q: string;
  types?: string[];
  machines?: string[];
  since?: number;
}

export async function searchDocs(p: SearchParams, signal?: AbortSignal): Promise<SearchResponse> {
  const url = new URL("/api/search", SEARCH_API);
  url.searchParams.set("q", p.q);
  if (p.types?.length) url.searchParams.set("types", p.types.join(","));
  if (p.machines?.length) url.searchParams.set("machines", p.machines.join(","));
  if (p.since) url.searchParams.set("since", String(p.since));
  const res = await fetch(url.toString(), { credentials: "include", signal });
  if (!res.ok) throw new Error(`search ${res.status}`);
  return res.json();
}

export async function fetchStats(signal?: AbortSignal): Promise<StatsResponse> {
  const res = await fetch(new URL("/api/stats", SEARCH_API).toString(), {
    credentials: "include",
    signal,
  });
  if (!res.ok) throw new Error(`stats ${res.status}`);
  return res.json();
}

export async function fetchDocument(id: string, signal?: AbortSignal): Promise<SearchHit> {
  const res = await fetch(new URL(`/api/doc/${encodeURIComponent(id)}`, SEARCH_API).toString(), {
    credentials: "include",
    signal,
  });
  if (!res.ok) throw new Error(`doc ${res.status}`);
  return res.json();
}
